import { exposeCreditCardModalToWindow } from '../../components/payments';
import { FormManager } from '@bark/bark-core/src/components/legacy-scripts/form-manager';
import { exposeQuickScrollToWindow } from "@bark/bark-core";
import { generateWalletOptions } from "../../helpers/payments/helpers";

export default function OneClickResponseSettings() {
	exposeQuickScrollToWindow();
	exposeCreditCardModalToWindow();

	const formManager = FormManager();

	let userHasOneClickEnabled = null;
	let oneClickEnabled = null;
	let isBillable = null;
	let formManagerHandle = 'one-click-response';
	let originalTemplateId = null;
	let selectedTemplate = null;
	let templates = [];
	let $cardModal = null;

	const onConfirmSetupIntent = () => {
		Bark.hideLoading();
		isBillable = true;
		enableOneClick();
		$('#form-manager-save').trigger('click');
	}

	const handleCardModalSuccess = (token) => {
		Bark.showLoading();
		window.BarkPaymentsCardModal.confirmSetupIntent(
			$cardModal.data('user-id'),
			token.id,
		)
			.then(onConfirmSetupIntent)
			.catch(() => {

				Bark.hideLoading();
				window.BarkPaymentsCardModal.showModalErrorText(
					$cardModal,
					_t("seller_settings_comms:one-click-response.errors.card-details")
				);
				window.BarkPaymentsCardModal.showCardModal($cardModal, generateWalletOptions(true, {
					isOnlySavingCard: true,
					userId: Bark.USER.userId,
					disableWallets: {
						paypal: true,
					},
					onWalletSetupComplete: onConfirmSetupIntent,
				}));
			});
	};

	const enableOneClick = () => {
		oneClickEnabled = true;

		$('#enable-one-click').prop('checked', oneClickEnabled);
		toggleView();

		formManager.dirty(formManagerHandle, formIsDirty());
	};

	const handleCardModalCancel = () => {
		updateFailed();
	};

	const checkAutoSave = function () {
		if (window.sessionStorage.one_click_setup_click) {
			$('#enable-one-click').trigger('click');
			$('#form-manager-save').trigger('click');

			window.sessionStorage.removeItem('one_click_setup_click');
		}
	};

	const toggleView = function () {
		if (oneClickEnabled) {
			showHideTemplateDropdown(true);
			$('.one-click-wrapper').addClass('one-click-enabled');
			$('.one-click-wrapper').removeClass('one-click-disabled');
		} else {
			showHideTemplateDropdown(false);
			$('.one-click-wrapper').addClass('one-click-disabled');
			$('.one-click-wrapper').removeClass('one-click-enabled');
		}
	};

	const showHideTemplateDropdown = function (show) {
		var $templateSelect = $('.template-select-block');
		if (show) {
			$('#template-select').attr('disabled', false);
			$templateSelect.removeClass('d-none');
		} else {
			$('#template-select').attr('disabled', true);
			$templateSelect.addClass('d-none');
		}
	};

	const updateOneClick = function (defer) {
		if ($('#enable-one-click').prop('checked') == true) {
			$('#template-select').trigger('change');
			saveSettings(defer);
		} else {
			disableOneClick(defer);
		}
	};

	const getSellerData = function () {
		var t = this;
		Bark.api(
			'seller/self/',
			{},
			function (data) {
				var sellerData = data.data;
				isBillable = sellerData['is_billable'];
				oneClickEnabled = sellerData['one_click_enabled'];
				// if we can't charge the seller then we should say their one click response is disabled
				if (!isBillable) {
					oneClickEnabled = false;
				}

				getTemplates();

				userHasOneClickEnabled = oneClickEnabled;
				$('.company-name').text(sellerData.company);
				$('#enable-one-click').prop('checked', oneClickEnabled);
				changeOneClickLabel(oneClickEnabled);
				if (typeof sellerData.links.website !== 'undefined') {
					$('.company-website').text(sellerData.links.website);
				}
				toggleView();
			},
			function (error) {
				// @todo error handling just to confirm
				bugsnagClient.notify(new Error('Seller self call failed'), { metaData: error });
			},
			'GET',
		);
	};

	const getTemplates = function () {
		Bark.emailService(
			'user/templates/',
			{},
			function (data) {
				templates = data.data;
				redraw(data);
			},
			function (error) {
				showGeneralError(_t("seller_settings_comms:one-click-response.errors.loading-templates"));
			},
			'GET',
		);
	};

	const makeTemplateDefault = function (id) {
		Bark.emailService(
			'user/template/' + id + '/default',
			{},
			function () {},
			function () {
				showGeneralError(_t("seller_settings_comms:one-click-response.errors.saving-response"));
			},
			'POST',
		);
	};

	const redraw = function (data) {
		var length = data.data.length;

		if (length > 0) {
			checkAutoSave();
			renderTemplates(data.data);
		} else {
			renderNoTemplates();
		}

		$('.waiting').removeClass('waiting');
	};

	const renderTemplates = function (data) {
		var templateSelect = document.getElementById('template-select');

		$('.set-up-one-click').addClass('d-none');
		$('.has-templates').removeClass('d-none');

		data.forEach((template) => {
			var option = document.createElement('option');
			option.value = template.id;
			option.text = template.title;

			if (template.is_default) {
				option.selected = true;
				setViewTemplateHref(template.id);
				originalTemplateId = template.id;
			}

			if (templateSelect) {
				templateSelect.appendChild(option);
			}
		});
	};

	const setViewTemplateHref = (id) => {
		var href = _l('/settings/template/' + id + '/');
		$('.js-view-template').attr('href', href);
	};

	const renderNoTemplates = function () {
		$('.has-templates').addClass('d-none');
		$('.set-up-one-click').removeClass('d-none');
	};

	const saveSettings = function (defer) {
		var t = this;
		Bark.api(
			'seller/one-click',
			{
				status: 1,
			},
			function (data) {
				oneClickEnabled = true;
				userHasOneClickEnabled = true;
				if (selectedTemplate) {
					makeTemplateDefault(selectedTemplate);
				}
				updateSuccess(defer);
			},
			function (error) {
				if (
					typeof error.responseJSON !== 'undefined' &&
					typeof error.responseJSON.error !== 'undefined' &&
					typeof error.responseJSON.error.message !== 'undefined'
				) {
					if (error.responseJSON.error.errors) {
						setError(error.responseJSON.error.errors['message']);
					} else {
						setError(error.responseJSON.error.message);
					}
				} else {
					setError(_t("seller_settings_comms:one-click-response.errors.char-limit"));
				}
				updateFailed(defer);
			},
			'POST',
			Bark.apiVersionHeader('v2'),
		);
	};

	const disableOneClick = function (defer) {
		var t = this;
		Bark.api(
			'seller/one-click',
			{
				status: 0,
			},
			function () {
				oneClickEnabled = false;
				userHasOneClickEnabled = false;
				updateSuccess(defer);
			},
			function (error) {
				if (
					typeof error.responseJSON !== 'undefined' &&
					typeof error.responseJSON.error !== 'undefined' &&
					typeof error.responseJSON.error.message !== 'undefined'
				) {
					if (error.responseJSON.error.errors) {
						setError(error.responseJSON.error.errors['message']);
					} else {
						setError(error.responseJSON.error.message);
					}
				} else {
					setError(_t("seller_settings_comms:one-click-response.errors.disabling"));
				}
				updateFailed(defer);
			},
			'POST',
			Bark.apiVersionHeader('v2'),
		);
	};
	const setError = function (msg) {
		$('.js-error-text').text(msg);
		$('.general-error').removeClass('d-none');
	};
	const updateSuccess = function (defer) {
		formManager.dirty(formManagerHandle, false);
		defer.resolve();
		toggleView();
		$('.general-error').addClass('d-none');
		quickScroll('#one_click_response');
	};
	const updateFailed = function (defer) {
		if (defer) defer.reject($('#one-click-message'));
	};

	const showGeneralError = function (error) {
		$('.one-click-message-container').prepend(
			'<div class="error-box text-center mb-3">' +
				'<p class="error mb-0">' +
				error +
				'</p>' +
				'</div>',
		);
	};

	const changeOneClickLabel = (isEnabled) => {
		if (isEnabled) {
			$('#one-click-label').text(_t("seller_settings_comms:one-click-response.one-click-response-enabled"));
		} else {
			$('#one-click-label').text(_t("seller_settings_comms:one-click-response.one-click-response-disabled"));
		}
	};

	const formIsDirty = function () {
		return (
			userHasOneClickEnabled !== $('#enable-one-click').prop('checked') ||
			(originalTemplateId !== selectedTemplate && templates.length > 1)
		);
	};

	const addListeners = function () {
		$('#enable-one-click').on('click.formlisten', (event) => {
			if (!isBillable) {
				window.BarkPaymentsCardModal.showCardModal($cardModal, {
					subheaderHtml:
					_t("seller_settings_comms:one-click-response.card-required-notice"),
					...generateWalletOptions(true, {
						isOnlySavingCard: true,
						userId: Bark.USER.userId,
						disableWallets: {
							paypal: true,
						},
						onWalletSetupComplete: onConfirmSetupIntent,
					})
				});
				event.stopPropagation();
				return false;
			}

			formManager.dirty(formManagerHandle, formIsDirty());
		});

		$('#enable-one-click').on('change.formlisten', function () {
			var isChecked = $(this).prop('checked');
			changeOneClickLabel(isChecked);
			showHideTemplateDropdown(isChecked);

			formManager.dirty(formManagerHandle, formIsDirty());
		});

		$('#template-select').on('change', function () {
			selectedTemplate = parseInt($(this).val());
			setViewTemplateHref(selectedTemplate);
			formManager.dirty(formManagerHandle, formIsDirty());
		});

		$('#one_click_response').on('click', '.js-menu-show-options', function (e) {
			e.preventDefault();
			var scope = $(this);

			if (scope.hasClass('open')) {
				scope.removeClass('open');
			} else {
				scope.addClass('open');

				window.setTimeout(function () {
					$('body').on('click.closemenu', function () {
						scope.removeClass('open');
						$('body').off('click.closemenu');
						$('body').off('touchend.closemenu');
					});
					$('body').on('touchend.closemenu', function (e) {
						$('body').off('click.closemenu');
						$('body').off('touchend.closemenu');
						scope.removeClass('open');
					});
				}, 10);
			}
		});

		//Card details section
		$('#one_click_response')
			.off('cardInfoChange')
			.on('cardInfoChange', function () {
				isBillable = true;
				oneClickEnabled = true;

				$('#enable-one-click').prop('checked', oneClickEnabled);
				toggleView();

				formManager.dirty(formManagerHandle, formIsDirty());
				$('#form-manager-save').trigger('click');
			});

		$('.js-create-one-click')
			.off('click')
			.on('click', () => {
				window.sessionStorage.one_click_setup_click = true;
			});
	};

	formManager.register(
		formManagerHandle,
		function (defer) {
			updateOneClick(defer);
		},
		function () {
			$('#enable-one-click').prop('checked', oneClickEnabled);
			$('#one-click-message').removeClass('is-invalid');
			formManager.dirty(formManagerHandle, false);
		},
	);

	$cardModal = window.BarkPaymentsCardModal.initCardModal(
		'.js-card-payment-modal',
		handleCardModalSuccess,
		handleCardModalCancel,
	);

	getSellerData();
	addListeners();
}
